import type { OverlayHookVariant } from "../types/types";

export const OVERLAY_MIN_HEIGHT_BY_VARIANT: Record<OverlayHookVariant, number> = {
    horizontal: 285,
    vertical: 325,
};
